// Google Recaptcha v3
import sls from "../env/sls.json"

export const GOOGLE_RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || "dummyKey"

export const RECAPTCHA_VERIFY_ENDPOINT = sls.RecaptchaVerifyEndpoint
